/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".errorInput[_ngcontent-%COMP%] {\r\n    border: 1px solid #dd2d2d;\r\n}\r\nlabel[_ngcontent-%COMP%]{\r\n    padding-top: 20px;\r\n}"];
export { styles as styles };
